import React from 'react';
import { oneOf, string } from 'prop-types';
import classNames from 'classnames';

import { NamedLink, Logo, LogoNew } from '../../components';

import css from './LinkedLogo.module.css';

const LinkedLogo = props => {
  const { className, rootClassName, format, alt, isAuthenticated, logoVariant, ...rest } = props;
  const classes = classNames(rootClassName || css.root, className);
  const effectiveLogoVariant = logoVariant === null ? 'new' : logoVariant;
  const LogoComponent = effectiveLogoVariant === 'new' ? LogoNew : Logo;

  return (
    <NamedLink className={classes} name={isAuthenticated ? 'Homepage' : 'LandingPage'} {...rest}>
      <LogoComponent format={format} className={css.logo} alt={alt} />
    </NamedLink>
  );
};

LinkedLogo.defaultProps = {
  className: null,
  rootClassName: null,
  format: 'desktop',
  logoVariant: null,
};

LinkedLogo.propTypes = {
  className: string,
  rootClassName: string,
  format: oneOf(['desktop', 'mobile']),
  logoVariant: string,
};

export default LinkedLogo;
